'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = getCookie;
function getCookieInBrowser(cName) {
  var cookie = document.cookie;

  if (cookie.length > 0) {
    var cStart = cookie.indexOf(cName + '=');

    if (cStart > -1) {
      cStart = cStart + cName.length + 1;

      var cEnd = cookie.indexOf(';', cStart);
      if (cEnd > -1) {
        return decodeURIComponent(cookie.slice(cStart, cEnd));
      }

      return decodeURIComponent(cookie.slice(cStart));
    }
  }
  return '';
}

function getCookieInMiniProgram(cName) {
  try {
    return wx.getStorageSync(cName);
  } catch (e) {}
  return '';
}

var isInMiniProgram = (typeof wx === 'undefined' ? 'undefined' : _typeof(wx)) === 'object' && typeof wx.getStorageSync === 'function';

function getCookie(cName) {
  if (isInMiniProgram) {
    return getCookieInMiniProgram(cName);
  }
  return getCookieInBrowser(cName);
}